import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from '../../../api.service';
// import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import Swal from 'sweetalert2';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'app-allocationdetail-delete',
  templateUrl: './allocationdetail-delete.component.html',
  styleUrls: ['./allocationdetail-delete.component.css']
})
export class AllocationdetailDeleteComponent implements OnInit {
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;

  displayPosition: boolean;
  rows = [];
  searchQR: any;
  value1: any;
  rangeValues: number[] = [0,100];

  Finals_excel : any;

  Bank_list_gets : any;
  product_list_gets  : any;
  portfolio_list_gets  : any;
  Bank_list : any;
  portfolio_list : any;
  booleans : any;
  product_list : any;
  User_details1 : any;

  show_list : any = 'portfolio';

  loading: Boolean = false;





  Excel_Datas :  any;
  saved_Fields : any;

  saved_Fields1 : any = [];
  saved_Fields2 : any = [];




  user_list_details : any;
  Company_details : any;
  Designation_details2 : any;
  report_to : any;
  report_to_id : any;
  company_name : any;
  report_to_design : any;

  Designation_details1 : any;
  MyuploadList = [];
  tempDefs = [];
  columnDefs = [];
  dataLoaded: boolean;
  data = [];
  login_Details: any;
  bankName: any;
  bankame: any;
  portfolio: any;
  product: any;


  timeLeft: number = 60;
  interval;
  bucket_details : any;

  bucket_detail : any;

  final_data : any;


  portfolio_bucket_id : any;
  transferData: any[];
  total_out_standing: number = 0;
  skip_count = 0;
  count = 1000;


  origianl_bank_list : any;
  original_portfolio_list : any;

  userFilter: any = { bank_name: '',portfolio:'',bucket:'',acc_no:'',passport : '',fint : '',alloc_by : '',alloc_to : '',date_of_assign:'',total_outstanding:'',last_update:''};
  constructor(
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private _api: ApiService,
    // private router: Router
  ) {

    this.bank_list_get();
    this.portfolio_list_get();

   }



  ngOnInit(): void {
    this.bucket_details = new Date().getTime();
    window.scrollTo(0, 0);
    this.portfolio_bucket_id = this.getFromLocal("portfolio_bucket_id");



    let a  = {
      skip : this.skip_count
    }
    console.log(a);
    this._api.fetch_data_using_allocated_list_by_bucket1(a).subscribe(
      (response: any) => {
        // console.log(response.Data);
        this.saved_Fields = response.Data;
        this.saved_Fields.forEach((item, i) => {
          console.log(item);
          let name =  JSON.parse(item.customer_details[0]);
          item.select_status = false;
          item.id = item._id || "",
          item.bank_name = item.bank_id || "",
          item.portfolio = item.porfolio_id || "",
          item.bucket = item.bucket_id || "",
          item.acc_no = item.acc_no || "",
          item.passport = item.passport_no || "",
          item.fint = item.finterstal_id || "",
          item.cname = name || "",
          item.alloc_by = item.assigned_by || "",
          item.alloc_to = item.assigned_to.email_id || "",
          item.date_of_assign = item.date_of_assign || "",
          item.total_outstanding = item.total_out_standing,
          item.last_update = item.updatedAt || ""

          if(i == this.saved_Fields.length - 1){
            console.log("DAtA in");
            this.loading = true;
            console.log(this.saved_Fields.length);
          }
        });
        
        


      }
    );








    this._api.user_details_list().subscribe(
      (response: any) => {
        this.user_list_details = response.Data;
        console.log(this.user_list_details);
      }
    );



 







    
    this.rows = [{ type: "Dog", name: "dog1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    { type: "Cat", name: "cat1" },
    ]

   

  }


 


 

  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  toggleEditable(status: any, index: any){
   this.saved_Fields[index].select_status = status;
  }

  fint(event){
      this.userFilter.fint = event.target.value;
  }
  passport(event){
    this.userFilter.passport = event.target.value;
  }
  accno(event){
    this.userFilter.acc_no = event.target.value;
  }
  bucket(event){
    this.userFilter.bucket = event.target.value;
  }
  getCif(event){
    this.userFilter.bucket = event.target.value;
  }
  getOTS(event){
    this.userFilter.total_out_standing = event.target.value;
  }

  getnat(event){
    this.userFilter.nationality = event.target.value;
  }
  getcycle(event){
    this.userFilter.cycle = event.target.value;
  }
  getflow(event){
    this.userFilter.flow_status = event.target.value;
  }

  getname(event){
    this.userFilter.customer_name = event.target.value;
  }




  showPositionDialog() {
    this.displayPosition = true;
  }


  getCustomer(page,data){
    let d = {
      passport_no :  data.passport_no,
      acc_no :  data.acc_no,
      bank_id : data.bank_id,
      portfolio_id :  data.porfolio_id,
      product_id : data.product_id, 
      finterstal_id: data.finterstal_id
    }
    this._api.fetch_customer_detail(d).subscribe(
      (response: any) => {
      

        if (response.Data[0].customer_details[0].insert_id != undefined) {
          var test_text = response.Data[0].customer_details;
          var convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        } else {
          console.log(response.Data[0].customer_details[0]);
          var test_text;
          console.log(response.Data[0].customer_details[0].passport_no);
          console.log(response.Data[0].customer_details[0].passport_no);
          if(response.Data[0].customer_details[0].passport_no !== undefined){
            test_text = [];
            test_text.push(response.Data[0].customer_details[0]);
          }else{
            test_text = JSON.parse(response.Data[0].customer_details[0]);
          }
          let convDatav = test_text;
          // console.log(convDatav['length']);
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        }

    
      }
    );
  }


  portfolio_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }


bank_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.origianl_bank_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }



  
  

delete_allocation(id){
  let a = {
    _id : id
  }
  console.log(a);
  this._api.allocation_details_delete(a).subscribe(
    (response: any) => {
      this.user_list_details = response.Data;
      console.log(this.user_list_details);
      this.ngOnInit();
    }
  );
}


next_rec(){
  this.skip_count = this.skip_count + 1000;
  this.count = this.count + 1000;

}
  
pre_rec(){
  this.skip_count = this.skip_count - 1000;
  this.count = this.count - 1000;
}





}
